import { IApplicationState } from '../../types/redux';

export const getInfrastructureRating = (state: IApplicationState): number | null => {
  return state.newReview.data.infrastructureRating.value;
};
